'use client'

import posthog from 'posthog-js'
import { PostHogProvider as PostHogProviderReact } from 'posthog-js/react'
import { ReactNode, useEffect } from 'react'
import { getPublicEnv, getBoolean, getCommonPosthogSettings } from '@tucan/utils'
import { flushPendingExceptions } from '@tucan/utils/error-tracking'

export function PostHogProvider({ children }: {
  children: ReactNode
}) {
  const { posthogConfig, posthogKey } = getCommonPosthogSettings()

  useEffect(() => {
    if (!posthogKey) {
      return
    }

    posthog.init( posthogKey, {
      ...posthogConfig,
      capture_pageview: false, // Disable automatic pageview capture, as we capture manually
      person_profiles: 'identified_only',
      // error tracking: report unhandled errors and rejections automatically,
      // handled errors are reported explicitly via `captureException`
      capture_exceptions: {
        capture_console_errors: false,
        capture_unhandled_errors: true,
        capture_unhandled_rejections: true,
      },
    })

    // errors captured during the first render happened before init
    flushPendingExceptions()
  }, [])

  if (!posthogKey || getBoolean(getPublicEnv('INHOUSE'))) {
    return <>{children}</>
  }

  return <PostHogProviderReact client={posthog}>{children}</PostHogProviderReact>
}
